(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_suco-verde-gift"] && !Shopify.designMode) return;
  try {
    class SucoVerdeGift extends HTMLElement {
    #abort = null;

    connectedCallback() {
      const root = this.closest('.suco-verde');
      if (!root) return;
      this.#abort = new AbortController();
      root.addEventListener('suco-verde:selection', (event) => this.#applySelection(event.detail), {
        signal: this.#abort.signal,
      });
      this.#fillLockedLabels();
      const checked = root.querySelector('input[data-variant-id]:checked');
      if (checked) this.#applySelection(checked.dataset);
    }

    disconnectedCallback() {
      this.#abort?.abort();
    }

    #fillLockedLabels() {
      const label = this.dataset.lockedLabel || '';
      for (const element of this.querySelectorAll('.suco-verde-gift-card__locked-label')) {
        element.textContent = label;
      }
    }

    #applySelection(source) {
      const selection = SucoVerdeGift.readSelection(source);
      if (!selection) {
        console.error('suco-verde-gift', {
          received: { ...source },
          expected: '{ quantity: integer >= 1, format: non-empty key, price: integer cents }',
        });
        return;
      }
      for (const card of this.querySelectorAll('.suco-verde-gift-card')) {
        const unlocked = SucoVerdeGift.isUnlocked(card.dataset, selection);
        card.toggleAttribute('data-gift-locked', !unlocked);
        SucoVerdeGift.showDiscount(card, selection.discount);
      }
    }

    static showDiscount(card, discount) {
      if (!card.hasAttribute('data-gift-discount')) return;
      const percent = discount > 0 ? discount : Number(card.dataset.giftDiscount);
      const icon = card.querySelector('.suco-verde-gift-card__discount-value');
      const pill = card.querySelector('.suco-verde-gift-card__free');
      if (icon) icon.textContent = `${percent}%`;
      if (pill) pill.textContent = `${percent}% OFF`;
    }

    static readSelection(source) {
      const quantity = Number(source?.quantity);
      const format = String(source?.format ?? '')
        .trim()
        .toLowerCase();
      if (!Number.isInteger(quantity) || quantity < 1 || !format) return null;
      return { quantity, format, price: Number(source.price), discount: Number(source.discount) || 0 };
    }

    static isUnlocked(rule, selection) {
      const formats = (rule.unlockFormats || '')
        .split(',')
        .map((key) => key.trim().toLowerCase())
        .filter(Boolean);
      if (formats.length > 0 && !formats.includes(selection.format)) return false;
      if (selection.quantity < Number(rule.unlockQuantity || 1)) return false;
      const minimum = Number(rule.unlockMinimum || 0);
      return minimum > 0 ? selection.price >= minimum : true;
    }
  }

  if (!customElements.get('suco-verde-gift')) {
    customElements.define('suco-verde-gift', SucoVerdeGift);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_suco-verde-nutrition"] && !Shopify.designMode) return;
  try {
    class SucoVerdeNutrition extends HTMLElement {
    connectedCallback() {
      const dialog = this.querySelector('dialog');
      if (!dialog) return;
      if (!('commandForElement' in HTMLButtonElement.prototype)) this.bindCommands(dialog);
      if (!('closedBy' in HTMLDialogElement.prototype)) this.bindLightDismiss(dialog);
    }

    bindCommands(dialog) {
      this.addEventListener('click', (event) => {
        const command = event.target.closest('button[command]')?.getAttribute('command');
        if (command === 'show-modal') dialog.showModal();
        if (command === 'close') dialog.close();
      });
    }

    bindLightDismiss(dialog) {
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });
    }
  }

  if (!customElements.get('suco-verde-nutrition')) {
    customElements.define('suco-verde-nutrition', SucoVerdeNutrition);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_suco-verde-quantity"] && !Shopify.designMode) return;
  try {
    class SucoVerdeQuantity extends HTMLElement {
    connectedCallback() {
      this.addEventListener('change', (event) => this.applySelection(event.target));
      this.applySelection(this.querySelector('input[data-variant-id]:checked'));
    }

    applySelection(input) {
      if (!input || !input.dataset.variantId) return;
      this.syncVariant(input);
      this.selection = {
        quantity: Number(input.dataset.quantity),
        format: input.dataset.format,
        price: Number(input.dataset.price),
        discount: Number(input.dataset.discount || 0),
      };
      this.dispatchEvent(
        new CustomEvent('suco-verde:selection', { bubbles: true, detail: this.selection }),
      );
    }

    syncVariant(input) {
      const form = document.getElementById(this.dataset.formId);
      const idInput = form?.querySelector('input[name="id"]');
      const quantityInput = form?.querySelector('input[name="quantity"]');
      if (!idInput || !quantityInput) {
        console.error('suco-verde-quantity', {
          formId: this.dataset.formId,
          expected: 'a form with id and quantity inputs',
        });
        return;
      }
      idInput.value = input.dataset.variantId;
      quantityInput.value = input.dataset.quantity;
    }
  }

  if (!customElements.get('suco-verde-quantity')) {
    customElements.define('suco-verde-quantity', SucoVerdeQuantity);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["sv-button"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sv-button')) {
    customElements.define(
      'sv-button',
      class SvButton extends HTMLElement {
        connectedCallback() {
          const productLink = this.querySelector('[data-sv-button-product]');
          const productArea = document.querySelector('[data-viewed-product][id]');
          if (!productLink || !productArea) return;
          productLink.hash = productArea.id;
        }
      },
    );
  }
  } catch(e) { console.error(e); }
})();

})();
